import React, { useState, useEffect } from 'react';
import styles from './CareerOpenings.module.css';
import CareerPopup from '../../components/CareerPopup/CareerPopup'; 

// 1. Import Firestore dependencies
import { db } from '../../firebase';
import { collection, query, where, onSnapshot } from 'firebase/firestore';

const CareerOpenings = () => {
  const [openIndex, setOpenIndex] = useState(0);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [selectedJob, setSelectedJob] = useState("");
  
  // 2. State for dynamic jobs
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);

  // 3. Fetch jobs from Firestore
  useEffect(() => {
    // We only want to show jobs where status is "open"
    const q = query(
      collection(db, "jobs"), 
      where("status", "==", "open"),
    );

    const unsubscribe = onSnapshot(q, (snapshot) => {
      const jobsData = snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      setJobs(jobsData);
      setLoading(false);
    }, (error) => {
      console.error("Error fetching jobs:", error);
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const handleApplyClick = (e, title) => {
    e.stopPropagation(); 
    setSelectedJob(title);
    setIsPopupOpen(true);
  };

  return (
    <section className={styles.wrapper}>
      <div className={styles.container}>
        <h2 className={styles.mainTitle}>Join Our Team</h2>

        <div className={styles.jobList}>
          {loading ? (
            <div className={styles.detailText}>Loading opportunities...</div>
          ) : jobs.length > 0 ? (
            jobs.map((job, index) => (
              <div 
                key={job.id || index} 
                className={`${styles.jobCard} ${openIndex === index ? styles.activeCard : ""}`}
              >
                <div className={styles.cardHeader} onClick={() => toggleAccordion(index)}>
                  <div className={styles.mainInfo}>
                    {/* Note: 'role' is used in your Popup, so we use it here */}
                    <h3 className={styles.jobTitle}>{job.role}</h3>
                    <div className={styles.metaRow}>
                      <span className={styles.orangeText}>{job.type}</span>
                      <span className={styles.orangeText}>{job.salary}</span>
                      <span className={styles.orangeText}>{job.experience}</span>
                    </div>
                  </div>

                  <div className={styles.actions}>
                    <button className={styles.toggleBtn}>
                      <span className={styles.arrowIcon}>
                        {openIndex === index ? '∧' : '∨'}
                      </span>
                    </button>
                    <button 
                      className={styles.applyBtn} 
                      onClick={(e) => handleApplyClick(e, job.role)}
                    >
                      Apply
                    </button>
                  </div>
                </div>

                <div 
                  className={styles.contentWrapper} 
                  style={{ maxHeight: openIndex === index ? "1000px" : "0px" }}
                >
                  <div className={styles.cardDetails}>
                    <div className={styles.section}>
                      <h4 className={styles.detailHeading}>Job Description:</h4>
                      <p className={styles.detailText}>{job.description}</p>
                    </div>
                    
                    {/* Showing 'What We're Looking For' from your Firestore schema */}
                    {job.lookingFor && (
                      <div className={styles.section}>
                        <h4 className={styles.detailHeading}>What We're Looking For:</h4>
                        <p className={styles.detailText}>{job.lookingFor}</p>
                      </div>
                    )}

                    {/* Handling Location if needed */}
                    <div className={styles.section}>
                       <h4 className={styles.detailHeading}>Location:</h4>
                       <p className={styles.detailText}>{job.location}</p>
                    </div>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className={styles.detailText}>No current openings. Check back soon!</div>
          )}
        </div>
      </div>

      {/* Popup component */}
      {isPopupOpen && (
        <CareerPopup 
          isOpen={isPopupOpen} 
          onClose={() => setIsPopupOpen(false)} 
          jobTitle={selectedJob} 
        />
      )}
    </section>
  );
};

export default CareerOpenings;